export default __webpack_public_path__ + "static/media/average.c3e5f3aa.svg";